import React from 'react';

/**
 * 등록일자(contract_date) 기간 필터 — 시작일·종료일 달력 입력
 */
const RegistrationDateRangeFilter = ({
  startDate = '',
  endDate = '',
  onStartDateChange,
  onEndDateChange,
  label = '등록일자',
  className = '',
}) => (
  <div className={className}>
    <label className="form-label">{label}</label>
    <div className="flex items-center gap-2">
      <input
        type="date"
        value={startDate}
        onChange={(e) => onStartDateChange(e.target.value)}
        className="input min-w-0 flex-1"
        aria-label={`${label} 시작일`}
      />
      <span className="text-gray-400 shrink-0">~</span>
      <input
        type="date"
        value={endDate}
        onChange={(e) => onEndDateChange(e.target.value)}
        className="input min-w-0 flex-1"
        aria-label={`${label} 종료일`}
        min={startDate || undefined}
      />
    </div>
  </div>
);

export default RegistrationDateRangeFilter;
